//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = value => (value ? value : "N/A");

export default {
  name: "AutomaticUploadsTable",
  props: [
    "tableClass",
    "bordered",
    "recordsTotal",
    "data",
    "typeName",
    "isLoading",
  ],
  components: {
    Table,
  },
  data: function () {
    return {
      separator: "horizontal",
      pagination: {
        rowsPerPage: 30,
      },
      columns: [
        {
          name: "name",
          required: true,
          label: "Nome",
          align: "left",
          field: row => row.name,
          format: DEFAULT_FORMAT,
        },
        {
          name: "publisher",
          align: "left",
          label: "Publisher",
          field: row => row.scheduling_publisher_name,
          format: DEFAULT_FORMAT
        },
        {
          name: "next-run",
          align: "left",
          label: "Next run",
          field: row => row.next_run,
          format: DEFAULT_FORMAT,
        },
        {
          name: "periodicity",
          align: "left",
          label: "Cron",
          field: (row) => row.cron ? row.cron : 'N/A',
        },
        {
          name: "config",
          align: "left",
          label: "Configurações adicionais",
          field: (row) => row.config && row.config ? row.config : 'N/A',
        }
      ],
    };
  },
  methods: {
    emitLine(event) {
      this.$emit("clicked-row", { ...event });
    },
  },
};
